import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './incubacaoConsultoriaActions';
import {
	setModoTela as setModoTelaIncubacao
} from '../incubacao/incubacaoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import TextoInput from '../texto/textoInput';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class IncubacaoConsultoriaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'
					style={{ padding: 0 }}>
					<ContentCard 
					style={{
						marginTop: 20,
						backgroundColor: '#0F2748',
						color: '#ffffff',
						borderRadius: 20,
						boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
						opacity: '80%'
					}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.incubacaoConsultoriaFormTitulo}</label>

							{!this.props.modoAdm &&
							<TextoInput chave='incubacaoConsultoriaFormTitulo' />}
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
									
									<LabelAndInputDate
										maxWidth={180}
										name='data_consultoria'
										label='Data da Consultoria *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_consultoria}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_consultoria: value
											});
										}} />

									<Field
										name='consultor'
										component={LabelAndInput}
										label='Nome do Consultor: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='area'
										component={LabelAndInput}
										label='Área da Consultoria: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='resumo'
										component={LabelAndTextarea}
										label='Resumo da consultoria: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
																		
									<Field
										name='resultados'
										component={LabelAndTextarea}
										label='Resultados obtidos com a consultoria: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />
										
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									{!this.props.modoAdm ? (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
										</Grid>
									) : (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => this.props.setModoTelaIncubacao('trilha')} />
										</Grid>
									)}
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaoConsultoriaForm = reduxForm({form: 'incubacaoConsultoriaForm', destroyOnUnmount: false})(IncubacaoConsultoriaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoConsultoriaForm')(state),
	registro: state.incubacaoConsultoria.registro,
	lista: state.incubacaoConsultoria.lista,
	incubacaoConsultoriaFormTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoConsultoriaFormTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, 
	setModoTelaIncubacao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoConsultoriaForm);
